"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @author yuqzho@microsoft.com, Ning Tang
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclarativeAgentWithExistingApiSpecGenerator = void 0;
const tslib_1 = require("tslib");
const m365_spec_parser_1 = require("@microsoft/m365-spec-parser");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../../error");
const question_1 = require("../../../question");
const defaultGenerator_1 = require("../defaultGenerator");
const templateNames_1 = require("../templates/templateNames");
const common_1 = require("./common");
const helper_1 = require("./helper");
const featureFlags_1 = require("../../../common/featureFlags");
const path_1 = tslib_1.__importDefault(require("path"));
const utils_1 = require("../utils");
const CopilotGptManifestUtils_1 = require("../../driver/teamsApp/utils/CopilotGptManifestUtils");
class DeclarativeAgentWithExistingApiSpecGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    componentName = "da-with-existing-api-generator";
    activate(context, inputs) {
        return (templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec ==
            inputs[question_1.QuestionNames.TemplateName]);
    }
    async getTemplateInfos(context, inputs, destinationPath, actionContext) {
        return (0, common_1.getTemplateInfosFromApiSpec)(context, inputs, m365_spec_parser_1.ProjectType.Copilot, actionContext);
    }
    async post(context, inputs, destinationPath, actionContext) {
        try {
            if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.SensitivityLabelEnabled)) {
                const teamsManifestPath = path_1.default.join(destinationPath, teamsfx_api_1.AppPackageFolderName, teamsfx_api_1.ManifestTemplateFileName);
                const declarativeCopilotManifestPathRes = await CopilotGptManifestUtils_1.copilotGptManifestUtils.getManifestPath(teamsManifestPath);
                if (declarativeCopilotManifestPathRes.isErr()) {
                    return (0, teamsfx_api_1.err)(declarativeCopilotManifestPathRes.error);
                }
                // best-effort
                await (0, utils_1.setGeneralSensitivityLabel)(context, declarativeCopilotManifestPathRes.value);
            }
            return await (0, common_1.generateFilesFromApiSpec)(context, inputs, destinationPath, m365_spec_parser_1.ProjectType.Copilot, this.componentName);
        }
        catch (e) {
            let error;
            if (e instanceof m365_spec_parser_1.SpecParserError) {
                error = (0, helper_1.convertSpecParserErrorToFxError)(e);
            }
            else {
                error = (0, error_1.assembleError)(e);
            }
            return (0, teamsfx_api_1.err)(error);
        }
    }
}
exports.DeclarativeAgentWithExistingApiSpecGenerator = DeclarativeAgentWithExistingApiSpecGenerator;
//# sourceMappingURL=declarativeAgentGenerator.js.map